<template>
  <div>
    <template v-if="dataMain != null && dataChartPies != null">
      <v-row>
        <v-col cols="12" md="4">
          <!-- prettier-ignore -->
          <CardUnit2 
          :cardMaxWidth="cardMaxWidth" 
          :cardName="$t('escb.consumption')"
          unitName="Output" 
 
          :energyHeader1="$t('escb.today')"
          :energy1Text="$t('escb.consumed')"
          :energy1Value="dataMain.gridImp.energyToday" 

          :energyHeader2="$t('escb.yesterday')"
          :energy3Text="$t('escb.consumed')"
          :energy3Value="dataMain.gridImp.energyYesterday" 

          :gaugeColor="gaugeColorLoad" 
          :powerValue="dataMain.gridImp.power" 
          :gaugeValue="parseFloat(dataMain.gridImp.power)" 
          
          :gaugeValueMax="15"
          > 
        </CardUnit2>
        </v-col>

        <v-col cols="12" md="4">
          <!-- prettier-ignore -->
          <CardUnit2 
          :cardMaxWidth="cardMaxWidth" 
          :cardName="$t('escb.gridImportDst')"
          unitName="Grid" 

          :energyHeader1="$t('escb.today')"
          :energy1Text="$t('escb.imported')"
          :energy1Value="dataMain.gridDst.energyToday" 


          :energyHeader2="$t('escb.yesterday')"
          :energy3Text="$t('escb.imported')"
          :energy3Value="dataMain.gridDst.energyYesterday" 


          :gaugeColor="gaugeColorGrid" 
          :powerValue="dataMain.gridDst.power" 
          :gaugeValue="parseFloat(dataMain.gridDst.power)"

          :gaugeValueMax="15"
          > 
        </CardUnit2>
        </v-col>

        <v-col cols="12" md="4">
          <!-- prettier-ignore -->
          <CardUnit2 
          :cardMaxWidth="cardMaxWidth" 
          :cardName="$t('escb.gridImportSup')"
          unitName="GridImport" 

          :energyHeader1="$t('escb.today')"
          :energy1Text="$t('escb.imported')"
          :energy1Value="dataMain.gridSup.energyToday" 

          :energyHeader2="$t('escb.yesterday')"
          :energy3Text="$t('escb.imported')"
          :energy3Value="dataMain.gridSup.energyYesterday" 

          :gaugeColor="gaugeColorGridImport" 
           :powerValue="dataMain.gridSup.power" 
          :gaugeValue="parseFloat(dataMain.gridSup.power)" 

          :gaugeValueMax="15"
          > 
        </CardUnit2>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" md="6" align="center">
          <v-card elevation="12" min-height="350">
            <v-card-text>
              <v-row justify="center">
                <v-col cols="12" md="6" align="center">
                  <v-row no-gutters>
                    <v-col cols="12">
                      <h5 class="text-center">{{ $t("escb.pieCharts.loadToday") }}</h5>
                    </v-col>

                    <v-col cols="12">
                      <ApexGradientDonutChart2
                        :data="dataChartPies.loadToday"
                        :colors="['#9C27B0', '#2196F3']"
                        :units="'kW'"
                        :label="[
                          $t('escb.pieCharts.loadY1'), //
                          $t('escb.pieCharts.loadY2'), //
                        ]"
                        :header="'AAA'"
                        :width="600"
                        :dark="$vuetify.theme.dark"
                      >
                      </ApexGradientDonutChart2
                    ></v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" md="6" align="center">
                  <v-row no-gutters>
                    <v-col cols="12">
                      <h5 class="text-center">{{ $t("escb.pieCharts.loadYesterday") }}</h5>
                    </v-col>

                    <v-col cols="12">
                      <ApexGradientDonutChart2
                        :data="dataChartPies.loadYesterday"
                        :colors="['#9C27B0', '#2196F3']"
                        :units="'kW'"
                        :label="[
                          $t('escb.pieCharts.loadY1'), //
                          $t('escb.pieCharts.loadY2'), //
                        ]"
                        :header="'AAA'"
                        :width="600"
                        :dark="$vuetify.theme.dark"
                      >
                      </ApexGradientDonutChart2
                    ></v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12" md="6" align="center">
          <v-card elevation="12" min-height="350">
            <v-card-title>
              <v-row>
                <v-col cols="12" align="center">
                  <h3>{{ $t("escb.outputs.header") }}</h3>
                </v-col>
              </v-row>
            </v-card-title>
            <v-card-text>
              <v-row justify="center">
                <v-col cols="6" md="3" align="center">
                  <v-row>
                    <v-col cols="12">
                      <h2>{{ $t("escb.outputs.boiler") }}</h2>
                    </v-col>
                    <v-col cols="12">
                      <v-icon size="80" color="amber">mdi-thermometer</v-icon>
                    </v-col>
                    <v-col cols="12">
                      <i>{{ $t("escb.outputs.off") }} </i>
                    </v-col>
                  </v-row>
                </v-col>

                <v-col cols="6" md="3" align="center">
                  <v-row>
                    <v-col cols="12">
                      <h2>{{ $t("escb.outputs.ac") }}</h2>
                    </v-col>
                    <v-col cols="12">
                      <v-icon size="80" color="light-green"> mdi-air-conditioner</v-icon>
                    </v-col>
                    <v-col cols="12"> <i>{{ $t("escb.outputs.off") }}</i> </v-col>
                  </v-row>
                </v-col>

                <v-col cols="6" md="3" align="center">
                  <v-row>
                    <v-col cols="12">
                      <h2>{{ $t("escb.outputs.pool") }}</h2>
                    </v-col>
                    <v-col cols="12">
                      <v-icon size="80" color="light-blue"> mdi-pool</v-icon>
                    </v-col>
                    <v-col cols="12"> <i>{{ $t("escb.outputs.off") }}</i> </v-col>
                  </v-row>
                </v-col>

                <v-col cols="6" md="3" align="center">
                  <v-row>
                    <v-col cols="12">
                      <h2>{{ $t("escb.outputs.heater") }}</h2>
                    </v-col>
                    <v-col cols="12">
                      <v-icon size="80" color="red"> mdi-heating-coil</v-icon>
                    </v-col>
                    <v-col cols="12">
                      <i>{{ dataMain.gridImp.power > 4.0 ? $t("escb.outputs.on")  :  $t("escb.outputs.off")  }}</i>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" lg="6" md="6">
          <AnyChart2 :heightSheet="365" :heightChart="350" :dark="$vuetify.theme.dark" :tabs="1" :cardHeader="$t('escb.todayConsumption')" :start="''" :stop="''" :ct="'Bar'" :card="true" :dashboard="true" />
        </v-col>
        <v-col cols="12" lg="6" md="6">
          <AnyChart2 :heightSheet="365" :heightChart="350" :dark="$vuetify.theme.dark" :tabs="0" :cardHeader="$t('escb.currentConsumption1h')" :start="''" :stop="''" :ct="'Line'" :card="true" :dashboard="true" />
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12">
          <AnyChart2 :heightSheet="365" :heightChart="350" :dark="$vuetify.theme.dark" :tabs="5" :cardHeader="$t('escb.currentConsumption6h')" :start="''" :stop="''" :ct="'Line'" :card="true" :dashboard="true" />
        </v-col>
      </v-row>
    </template>
    <template v-else>
      <LoadingData />
    </template>
  </div>
</template>

<script>
import * as MyFormat from "../../components/format.js";

import { ServiceClient } from "../../service_client/index.js";

import { svgGaugeColors } from "../../colors.js";

import AnyChart2 from "../../components/charts/AnyChart2.vue";

import CardUnit2 from "../../components/cards/CardUnit2.vue";

import ApexGradientDonutChart2 from "../../components/charts/apexcharts/ApexGradientDonutChart2.vue";

import LoadingData from "../../components/LoadingData.vue";

export default {
  name: "ESCBDashboard",
  components: {
    ApexGradientDonutChart2,
    LoadingData,
    AnyChart2,
    CardUnit2,
  },
  data() {
    return {
      task: 0,

      dataMain: null,
      dataChartPies: null,

      timer: null,

      cardMaxWidth: 1000,

      gaugeColorLoad: [
        { offset: 0, color: svgGaugeColors.load[0] },
        { offset: 100, color: svgGaugeColors.load[1] },
      ],
      gaugeColorBattery: [
        { offset: 0, color: svgGaugeColors.battery[0] },
        { offset: 100, color: svgGaugeColors.battery[1] },
      ],
      gaugeColorInverter: [
        { offset: 0, color: svgGaugeColors.inverter[0] },
        { offset: 100, color: svgGaugeColors.inverter[1] },
      ],
      gaugeColorGrid: [
        { offset: 0, color: svgGaugeColors.grid[0] },
        { offset: 100, color: svgGaugeColors.grid[1] },
      ],
      gaugeColorGridImport: [
        { offset: 0, color: svgGaugeColors.gridImport[0] },
        { offset: 100, color: svgGaugeColors.gridImport[1] },
      ],
      gaugeColorPV: [
        { offset: 0, color: svgGaugeColors.pv[0] },
        { offset: 100, color: svgGaugeColors.pv[1] },
      ],
    };
  },

  created() {
    setTimeout(() => {
      this.getData("escbmain");
    }, 0);
    setTimeout(() => {
      this.getData("escbchartpies");
    }, 1000);
  },
  mounted() {
    this.pollData();
  },

  computed: {},
  methods: {
    onResize() {},
    pollData() {
      this.timer = setInterval(() => {
        switch (this.task++) {
          case 0:
            this.getData("escbmain");
            break;
          case 1:
            this.getData("escbchartpies");
            break;
          default:
            this.task = 0;
            break;
        }
      }, 2000);
    },
    getData(json) {
      ServiceClient.dataCore(ServiceClient.getAPIUrl(json), null, null, "GET")
        .then((data) => {
          if (json == "escbmain") {
            this.dataMain = data;

            this.dataMain.gridImp.energyToday = MyFormat.formatEnergyVal(this.dataMain.gridImp.energyToday);
            this.dataMain.gridImp.energyYesterday = MyFormat.formatEnergyVal(this.dataMain.gridImp.energyYesterday);

            this.dataMain.gridDst.energyToday = MyFormat.formatEnergyVal(this.dataMain.gridDst.energyToday);
            this.dataMain.gridDst.energyYesterday = MyFormat.formatEnergyVal(this.dataMain.gridDst.energyYesterday);

            this.dataMain.gridSup.energyToday = MyFormat.formatEnergyVal(this.dataMain.gridSup.energyToday);
            this.dataMain.gridSup.energyYesterday = MyFormat.formatEnergyVal(this.dataMain.gridSup.energyYesterday);

            this.dataMain.gridImp.power = MyFormat.formatPowerVal(this.dataMain.gridImp.power);
            this.dataMain.gridDst.power = MyFormat.formatPowerVal(this.dataMain.gridDst.power);
            this.dataMain.gridSup.power = MyFormat.formatPowerVal(this.dataMain.gridSup.power);
          } else if (json == "escbchartpies") {
            this.dataChartPies = data;
          }
        })
        .catch((error) => {
          if (json == "escbmain") {
            this.dataMain = ServiceClient.handleUnauthorized(error, this.$router);
          } else if (json == "escbchartpies") {
            this.dataChartPies = ServiceClient.handleUnauthorized(error, this.$router);
          }
        });
    },
  },
  beforeDestroy() {
    clearInterval(this.timer);

    window.removeEventListener("resize", this.onResize);
  },
  destroyed() {},
};
</script>

<style scoped>
.icon-overflow {
  position: absolute;
  top: -30px;
  left: 10%;
  transform: translateX(50%);
}
.v-card {
  margin-bottom: 16px;
}
</style>
